import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** KPI de dashboard / detalle: etiqueta en mayúsculas + valor grande. */
export function KpiCard({
  label,
  value,
  hint,
  className,
}: {
  label: string
  value: ReactNode
  hint?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-border bg-card p-4 shadow-card',
        className,
      )}
    >
      <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">
        {label}
      </p>
      <p className="mt-1 text-[30px] leading-none font-semibold tracking-tight text-foreground">
        {value}
      </p>
      {hint != null && (
        <p className="mt-2 text-xs text-muted-foreground">{hint}</p>
      )}
    </div>
  )
}
